import React from 'react';
import { Box } from '@mui/material';
import CalendarTodayIcon from '@mui/icons-material/CalendarToday';
import LogFieldCard from './LogFieldCard';

const LogDateField = ({
  value,
  onClick,
  label = 'Date',
  placeholder = 'Select date',
  showLabel = true,
  sx = {},
  containerSx = {},
  ...props
}) => (
  <Box sx={{ width: '100%', ...containerSx }}>
    <LogFieldCard
      label={label}
      value={value}
      placeholder={placeholder}
      onClick={onClick}
      showLabel={showLabel}
      kind="date"
      icon={CalendarTodayIcon}
      sx={sx}
      ariaLabel={`${label.toLowerCase()} picker`}
      {...props}
    />
  </Box>
);

export default LogDateField;
